import React, { useState } from "react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AmbassadorProfile from "../../../screens/my-profile/ambassador-profile";
import AppDrawer from "../../drawer";
import { DefaultButton } from ".";
import { Box } from "@mui/material";

interface AmbassadorDetailsButtonProps {
  label?: string;
  disabled?: boolean;
  data?: any;
  limitedAccess?: boolean;
  renderButton?: React.ReactNode;
  fullWidth?: boolean;
  showInitiativesNote?: boolean;
}

export default function AmbassadorDetailsButton({
  label = "View Profile",
  renderButton,
  disabled = false,
  data,
  limitedAccess = false,
  fullWidth = false,
  showInitiativesNote = false,
}: AmbassadorDetailsButtonProps) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDrawerOpen(true);
  };

  return (
    <>
      {renderButton ? <Box onClick={handleClick}>{renderButton}</Box> : (
        <DefaultButton
          size="small"
          startIcon={<AccountCircleOutlinedIcon />}
          onClick={handleClick}
          fullWidth={fullWidth}
        >
          {label}
        </DefaultButton>
      )}

      <AppDrawer
        title="Ambassador Profile"
        anchor="right"
        open={drawerOpen}
        onClose={handleCloseDrawer}
      >
        <AmbassadorProfile
          fetchData={false}
          data={data}
          showCompanyName
          limitedAccess={limitedAccess}
          editable={false}
          showInitiativesNote={showInitiativesNote}
        />
      </AppDrawer>
    </>
  );
}
